export default {
    
    // Settings for display grid
    grid: {
        row: 8, // Items per row
        col: 4, // Items per column

        padding: {
            x: 0.2, // X Padding of an image 
            y: 0.2, // Y Padding of an image
        },
    },

    // Settings for single icon
    icon: {
        width: 0.4, // Width of an icon
        height: 0.4, // Height of an icon

        maxScale: "1.5 1.5 1.5", // Scale of hovered element
    },

    // Settings for navigation component
    navigation: {

        buttons: {
            size: 0.3, // Size of navigation button

            // Nav buttons padding
            padding: {
                x: 0.1,
                y: 0,
            }
        }
    },
    
}



// WEBPACK FOOTER //
// ./src/assets/devfest/grid.js